<div class="authentication">
    <div class="page-404 container">
        <div class="row">
            <div class="col-md-6">
                <div class="full-height">
                    <div class="vertical-align full-height pdd-horizon-70">
                        <div class="table-cell">
                            <h1 class="text-dark font-size-80 text-light">
                                {{ 'pages.not-found.opps' | translate }}
                            </h1>
                            <p class="lead lh-1-8">
                                {{
                                    'pages.not-found.hello-message' | translate
                                }}
                                <br />
                                {{ 'pages.not-found.back-message' | translate }}
                            </p>
                            <a [routerLink]="['/']" class="btn btn-info">
                                {{ 'pages.not-found.get-me-back' | translate }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-5 ml-auto hidden-sm hidden-xs">
                <div class="full-height height-100">
                    <div class="vertical-align full-height">
                        <div class="table-cell">
                            <img
                                class="img-responsive"
                                src="images/others/404.png"
                                alt=""
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
